'use strict'

import angular from 'angular'
import './buySheet.service'
import './buySheet.controller'
import './buySheetError.component'
import './buySheetForbidden.component'
import './buySheetInfo.component'
import './buySheetNav.component'
import './buySheetWrapper.component'
import './buySheetMain.component'
import './buySheetPanel.component'
import './buySheetSimpleFieldsList.component'
import './buySheetComplexFieldsList.component'
import './buySheetTableComplexFieldsList.component'
import './buySheetField.component'
import './buySheetGeoLocationsField.component'

import buySheetTemplateUrl from './buySheet.html';

angular.module('buySheet', ['buySheet.controllers', 'buySheet.services', 'buySheet.components'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('buySheet', {
            parent: 'layout',
            url: '/items/orders/:orderId/buySheet',
            templateUrl: buySheetTemplateUrl,
            controller: 'BuySheetController',
            params: {
                backTo: null
            }
        })
    }])